import { useQuery } from '@tanstack/react-query';
import { CustomPageType } from '@ViewModels';
import { useApiClientContext } from '../context';

const BASE_QUERY_KEY = 'SurveyCustomPageStyle';

interface CustomPageStyleResponse {
	html?: string;
	hasCustomization: boolean;
	error?: string;
}

export const useCustomPageStyleByToken = ({
	token,
	type,
	enabled = true,
}: {
	token?: string;
	type: CustomPageType;
	enabled?: boolean;
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery<CustomPageStyleResponse>({
		enabled: enabled && !!token,
		queryFn: async (): Promise<CustomPageStyleResponse> => {
			try {
				const response = await fetch(`${apiClient.baseUrl}/survey/byToken/custom-page-style/${type}?token=${token}`);

				const htmlContent = await response.text();

				if (!htmlContent || htmlContent.trim() === '') {
					return { hasCustomization: false, error: 'Empty response received' };
				}

				return {
					hasCustomization: true,
					html: htmlContent,
				};
			} catch (networkError) {
				console.error('Network error fetching custom page style:', networkError);
				return { hasCustomization: false, error: 'Network error occurred' };
			}
		},
		queryKey: [BASE_QUERY_KEY, token, type],
		retry: (failureCount, error) => {
			// Only retry on network errors, not on 4xx client errors
			return failureCount < 2 && !(error as any)?.message?.includes('HTTP 4');
		},
	});
};
